import React from "react";

import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const store = useAppSelector(selectStore);

    return (
        <>
            Understand the full spectrum of competition surrounding your {store?.name} store, from direct rivals to broader retail alternatives.
            Identify which brands are capturing customer attention nearby and evaluate how their presence influences your store's performance.
            Use these insights to sharpen your value proposition and make strategic decisions about advertising placement to win future customers and stand out in a crowded marketplace.
        </>
    );
};

export default Subtitle;
